import './TodayMatches.css';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { selectTodayMatches } from '@selectors/matches';
import { getTeamDisplayName } from '@utils/teamDisplayName';

const TodayMatches = ({ matches, teams }) => {
  if (!matches?.length || !teams) {
    return null;
  }
  return (
    <div className="today-matches">
      <span className="today-label">Hoy juegan:</span>
      {matches.map((m) => {
        return (
          <div key={m.mid} className="today-match">
            <span className="match-time">
              {moment(m.datetime).format('HH:mm')}
            </span>
            <span> - </span>
            <span className="match-teams">
              {getTeamDisplayName(teams, m.teamHome)} vs{' '}
              {getTeamDisplayName(teams, m.teamAway)}{' '}
              {m.stage === 'groups' ? `(${m.group.toUpperCase()})` : null}
            </span>
          </div>
        );
      })}
    </div>
  );
};

TodayMatches.displayName = 'TodayMatches';
TodayMatches.propTypes = {
  matches: PropTypes.array,
};
TodayMatches.defaultProps = {
  matches: [],
};

export const mapStateToProps = (state) => ({
  matches: selectTodayMatches(state),
  teams: state.teams,
});

export default connect(mapStateToProps)(TodayMatches);
